import {
    CHANGE_DISPLAYED_USERS,
    CHANGE_USER_LIST_STORE_SETTINGS,
    CHANGE_USERS_LIST_SETTINGS,
    GET_ARAG_USER_BY_ID,
    GET_ARAG_USER_BY_ID_FAIL,
    GET_ARAG_USER_BY_ID_SUCCESS,
    GET_USER_GROUPS,
    GET_USER_GROUPS_FAIL,
    GET_USER_GROUPS_SUCCESS,
    GET_USER_LEVELS,
    GET_USER_LEVELS_FAIL,
    GET_USER_LEVELS_SUCCESS,
    RECEIVE_BAD_REQUEST_GET_USERS,
    RECEIVE_GET_USERS,
    REQUEST_GET_USERS,
    TOGGLE_CONFIRM_DIALOG,
    TOGGLE_MODAL,
    USERS_PAGE_SHIFT
} from "./index";

export function changeUserListStoreSettings(payload) {
    return {
        type: CHANGE_USER_LIST_STORE_SETTINGS,
        payload: payload
    }
}

//action that requests arag user from the api
export function getAragUserById(payload) {
    return {
        type: GET_ARAG_USER_BY_ID,
        payload: payload
    }
}

//action that receives arag user by id
export function getAragUserByIdSuccess(payload) {
    return {
        type: GET_ARAG_USER_BY_ID_SUCCESS,
        payload: payload
    }
}

//action that receives error get arag user by id
export function getAragUserByIdFail(payload) {
    return {
        type: GET_ARAG_USER_BY_ID_FAIL,
        payload: payload
    }
}

//action that requests the user levels
export function getUserLevels() {
    return {
        type: GET_USER_LEVELS
    }
}

//action that receives the user levels
export function getUserLevelsSuccess(payload) {
    return {
        type: GET_USER_LEVELS_SUCCESS,
        payload: payload
    }
}

//action that receives error get the user levels
export function getUserLevelsFail(payload) {
    return {
        type: GET_USER_LEVELS_FAIL,
        payload: payload
    }
}

//action that requests the user groups
export function getUserGroups() {
    return {
        type: GET_USER_GROUPS
    }
}

//action that receives the user groups
export function getUserGroupsSuccess(payload) {
    return {
        type: GET_USER_GROUPS_SUCCESS,
        payload: payload
    }
}

//action that receives failed response get user groups
export function getUserGroupsFail(payload) {
    return {
        type: GET_USER_GROUPS_FAIL,
        payload: payload
    }
}

export function changeDisplayedUsers(data) {
	return {
		type: CHANGE_DISPLAYED_USERS,
		payload: data
	}
}


export function changeUsersListSettings(settingKey, value) {
	return {
		type: CHANGE_USERS_LIST_SETTINGS,
		payload: {
			key: settingKey,
			value: value
		}
	}
}

export function usersPageShift(direction) {
	return {
		type: USERS_PAGE_SHIFT,
		payload: direction
	}
}

//action that makes the get request for the solicitors
export function requestGetUsers(token) {
	return {
		type: REQUEST_GET_USERS,
		payload: token
	}
}

//action that receives the fetched solicitors from the get request
export function receiveGetUsers(solicitors) {
	return {
		type: RECEIVE_GET_USERS,
		payload: solicitors
	}
}

//action that receives bad request  fetching solicitors from the get request
export function receiveBadRequestGetUsers(response) {
	return {
		type: RECEIVE_BAD_REQUEST_GET_USERS,
		payload: response
	}
}

//action that closes and opens the displayed modal
export function toggleModal() {
	return {
		type: TOGGLE_MODAL
	}
}


//action that closes and opens the confirm modal
export function toggleConfirmDialog() {
	return {
		type: TOGGLE_CONFIRM_DIALOG
	}
}



